import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('@ls/feature-app-layout').then((m) =>
        m.createAppLayoutRoutes([
          {
            path: '',
            loadChildren: () =>
              import('@lce/feature-home').then((m) => m.routes),
          },
        ])
      ),
  },
];
